const DAYS = {
	1: 'sunday',
	2: 'monday',
	3: 'tuesday',
	4: 'wednesday',
	5: 'thursday',
	6: 'friday',
	7: 'saturday'
}

/**@param {Date} date */
function dateToDD_MM_YYYY(date) {
	let month = `${date.getMonth() + 1}`.padStart(2, '0')
	let day = `${date.getDate()}`.padStart(2, '0')
	let year = date.getFullYear()
	let output = day + '.' + month + '.' + year
	return output
}

/**@param {Array<Array>} masterArray*/
function lengthOfLongestArrayInMatrix(masterArray) {
	const index = masterArray.reduce((p, c, i, a) => (a[p].length > c.length ? p : i), 0)
	return masterArray[index].length
}

export const capitalize = (string) => {
	return string.replace(/^\w/, (c) => c.toUpperCase())
}

function generateId() {
	return (
		Math.random()
			.toString(36)
			.substring(2, 15) +
		Math.random()
			.toString(36)
			.substring(2, 15)
	)
}

function kFormatter(num) {
	return Math.abs(num) > 999
		? Math.sign(num) * (Math.abs(num) / 1000).toFixed(2) + 'k'
		: Math.sign(num) * Math.abs(num)
}

function kMinutesToHours(num) {
	return Math.abs(num) > 999 ? (Math.abs(num) / 60).toFixed(1) + 'h' : Math.sign(num) * Math.abs(num)
}

/**@param {Object[]} items @param {String} str @param {String} objectKey*/
function filterArrayOfObjectsWithString(items, str, objectKey) {
	if (!str) return items
	return items.filter(
		(item) =>
			item[objectKey] &&
			item[objectKey]
				.toString()
				.toLowerCase()
				.includes(str.toLowerCase())
	)
}

/**@param {Object} object */
function saveToQueryParams(object) {
	/**@type {String} */
	let queryString = ''
	for (var key in object) {
		if (queryString != '') {
			queryString += '&'
		}
		queryString += key + '=' + JSON.stringify(object[key])
	}
	window.location.search = queryString
	return queryString
}

/**@param {'custom_time' | 'last_week' | 'last_month' | 'last_year' | 'last_day' | 'last_quarter'} value
 * @returns {{ timeTo: String, timeFrom: String }} format: YYYY-MM-DD*/
function getTimeByType(value) {
	let filter = { timeTo: '', timeFrom: '' }
	if (value === 'custom_time') return

	const ONE_DAY_MS = 1000 * 60 * 60 * 24
	const ONE_WEEK_MS = ONE_DAY_MS * 7
	const ONE_MONTH_DAYS = 31
	const ONE_YEAR_DAYS = 365

	if (value === 'last_day') {
		const yesterday = new Date()
		yesterday.setDate(yesterday.getDate() - 1)
		yesterday.setHours(0, 0, 0, 0)
		// Format as local date string (YYYY-MM-DD) to match date picker format
		const year = yesterday.getFullYear()
		const month = String(yesterday.getMonth() + 1).padStart(2, '0')
		const day = String(yesterday.getDate()).padStart(2, '0')
		const yesterdayStr = `${year}-${month}-${day}`
		filter.timeFrom = yesterdayStr
		filter.timeTo = yesterdayStr
		return filter
	}

	const today = new Date()
	today.setDate(today.getDate() - 1)
	today.setHours(0, 0, 0, 0)
	// Format as local date string (YYYY-MM-DD) to match date picker format
	const yearTo = today.getFullYear()
	const monthTo = String(today.getMonth() + 1).padStart(2, '0')
	const dayTo = String(today.getDate()).padStart(2, '0')
	filter.timeTo = `${yearTo}-${monthTo}-${dayTo}`

	let from = null
	if (value === 'last_week') {
		from = new Date(Date.now() - ONE_WEEK_MS)
	} else if (value === 'last_month' || !value) {
		from = new Date()
		from.setMonth(from.getMonth() - 1)
	} else if (value === 'last_quarter') {
		from = new Date(Date.now() - ONE_DAY_MS * ONE_MONTH_DAYS * 3)
	} else if (value === 'last_year') {
		from = new Date(Date.now() - ONE_DAY_MS * ONE_YEAR_DAYS)
	}

	if (from) {
		from.setHours(0, 0, 0, 0)
		// Format as local date string (YYYY-MM-DD) to match date picker format
		const yearFrom = from.getFullYear()
		const monthFrom = String(from.getMonth() + 1).padStart(2, '0')
		const dayFrom = String(from.getDate()).padStart(2, '0')
		filter.timeFrom = `${yearFrom}-${monthFrom}-${dayFrom}`
	}
	return filter
}

function findMaxAndMin(arr) {
	let max = -Infinity
	let min = Infinity
	for (let i = 0; i < arr.length; i++) {
		const item = +arr[i]
		if (item > max) max = item
		if (item < min) min = item
	}
	return {
		min,
		max
	}
}

/**@param {String} url*/
function isValidUrl(url) {
	let regEx = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/gm
	return regEx.test(url)
}

/**@param {String} url*/
function stringInEnglish(string) {
	if (!string) return false
	const english = /^[A-Za-z0-9 ]*$/
	return english.test(string)
}

/**@param {Number[]} numbers*/
function sortParallelArrays(numbers, strings) {
	const bothArray = [...numbers].map((item, index) => {
		return {
			num: item,
			str: strings[index]
		}
	})
	bothArray.sort((a, b) => b.num - a.num)
	return bothArray
}

/**@param {Date} date */
function getHoursPassed(date) {
	const now = new Date()
	const timeDiff = now.getTime() - date.getTime()
	const hoursPassed = timeDiff / 1000 / 60 / 60
	return hoursPassed
}

function getWeekDaysNames() {
	const weekDaysNames = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']
	return weekDaysNames
}

function getDayHours(minuteSteps = 15) {
	const hours = []
	for (let i = 0; i < 24; i++) {
		for (let j = 0; j < 60; j += minuteSteps) {
			const hour = i < 10 ? '0' + i : i
			const minute = j < 10 ? '0' + j : j
			hours.push(hour + ':' + minute)
		}
	}
	return hours
}

function convertUtcHourToLocalHour(hour) {
	const hourParts = hour.split(':')
	const [utcHour, utcMinute] = hourParts
	const localTime = new Date()
	localTime.setUTCHours(utcHour)
	localTime.setUTCMinutes(utcMinute)
	const localHour = localTime.getHours()
	const localMinute = localTime.getMinutes()
	const localHourStr = localHour < 10 ? '0' + localHour : localHour
	const localMinuteStr = localMinute < 10 ? '0' + localMinute : localMinute
	return `${localHourStr}:${localMinuteStr}`
}

function convertLocalHourToUtcHour(hour) {
	const hourParts = hour.split(':')
	const [localHour, localMinute] = hourParts
	const utcTime = new Date()
	utcTime.setHours(localHour)
	utcTime.setMinutes(localMinute)
	const utcHour = utcTime.getUTCHours()
	const utcMinute = utcTime.getUTCMinutes()
	const utcHourStr = utcHour < 10 ? '0' + utcHour : utcHour
	const utcMinuteStr = utcMinute < 10 ? '0' + utcMinute : utcMinute
	return `${utcHourStr}:${utcMinuteStr}`
}

/**
 * @param {Number} dayNum
 * @returns {String}
 * */
function getWeekDayName(dayNum) {
	if (!dayNum) return
	if (_isDayNumValid(dayNum)) {
		return DAYS[dayNum]
	}
}

function isCharValid(lang, char) {
	if (!lang || !char) return false
	const specialCharRegex = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?0-9 ]/

	const langsRegex = {
		english: /[a-zA-Z]/,
		hebrew: /[א-ת]/,
		portuguese: /[a-zA-ZçÇáÁàÀãÃâÂéÉèÈêÊíÍìÌîÎóÓòÒõÕôÔúÚùÙûÛ]/,
		russian: /[а-яА-ЯёЁ]/,
		spanish: /[a-zA-ZáÁàÀãÃâÂéÉèÈêÊíÍìÌîÎóÓòÒõÕôÔúÚùÙûÛñÑ]/,
		arabic: /[ء-ي]/,
		amharic: /[አ-ፚ]/,
		polish: /[a-zA-ZąĄćĆęĘłŁńŃóÓśŚźŹżŻ]/,
		ukrainian: /[а-яА-ЯїЇєЄґҐіІ]/
	}

	const isValid = langsRegex[lang].test(char) || specialCharRegex.test(char)
	return isValid
}

/**
 * @param {Number} dayNum
 * @returns {Boolean}
 * */
function _isDayNumValid(dayNum) {
	return dayNum >= 1 && dayNum <= 7
}

function getNumRange(start, end) {
	const range = []
	for (let i = start; i <= end; i++) {
		range.push(i)
	}
	return range
}

function getWeeksRange(start, end) {
	const weeksNames = ['1st week', '2nd week', '3rd week', '4th week', '5th week']
	const range = []
	for (let i = start; i <= end; i++) {
		range.push(weeksNames[i - 1])
	}
	return range
}

function isPastDate(date) {
	date = new Date(date)
	const now = new Date()
	if (date < now) {
		return true
	}
	return false
}

function isValidEmail(email) {
	if (!email) return false
	const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	return emailRegex.test(email)
}

function flattenArray(arr) {
	let result = []

	arr.forEach((element) => {
		if (Array.isArray(element)) {
			result = result.concat(flattenArray(element))
		} else {
			result.push(element)
		}
	})

	return result
}

/** Etc/GMT zones: Etc/GMT-8 = UTC+8, Etc/GMT+5 = UTC-5. Sign must be explicit. */
function timeZoneForGmt(gmt) {
	const n = Number(gmt)
	if (Number.isNaN(n)) return null
	const sign = n <= 0 ? '+' : '-'
	return `Etc/GMT${sign}${Math.abs(n)}`
}

/** YYYY-MM-DD in company timezone (DB stores UTC; UI shows company-local). */
function companyLocalDateStr(date, gmt) {
	const tz = timeZoneForGmt(gmt)
	if (!tz || !date) return null
	const parsed = date instanceof Date ? date : new Date(date)
	if (Number.isNaN(parsed.getTime())) return null
	return parsed.toLocaleDateString('en-CA', { timeZone: tz })
}

function _parseDate(date) {
	if (!date) return null
	const parsed = date instanceof Date ? date : new Date(date)
	return Number.isNaN(parsed.getTime()) ? null : parsed
}

/** HH:MM in company timezone. No browser-local fallback. */
function formatHMInCompanyTz(date, gmt, emptyLabel = '--:--') {
	const parsed = _parseDate(date)
	const tz = timeZoneForGmt(gmt)
	if (!parsed || !tz) return emptyLabel
	return parsed.toLocaleTimeString('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit' })
}

/** HH:MM:SS in company timezone. No browser-local fallback. */
function formatTimeInCompanyTz(date, gmt, emptyLabel = '--:--') {
	const parsed = _parseDate(date)
	const tz = timeZoneForGmt(gmt)
	if (!parsed || !tz) return emptyLabel
	return parsed.toLocaleTimeString('en-GB', {
		timeZone: tz,
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
	})
}

/** HH:MM in company timezone, or browser-local when gmt is unknown. */
function formatHMInCompanyTzOrBrowserLocal(date, gmt, emptyLabel = '--:--') {
	const parsed = _parseDate(date)
	if (!parsed) return emptyLabel
	const tz = timeZoneForGmt(gmt)
	if (tz) {
		return parsed.toLocaleTimeString('en-GB', { timeZone: tz, hour: '2-digit', minute: '2-digit' })
	}
	return parsed.toLocaleTimeString('en-GB', { hour: '2-digit', minute: '2-digit' })
}

export default {
	filterArrayOfObjectsWithString,
	generateId,
	sortParallelArrays,
	kFormatter,
	saveToQueryParams,
	getTimeByType,
	findMaxAndMin,
	kMinutesToHours,
	lengthOfLongestArrayInMatrix,
	dateToDD_MM_YYYY,
	isValidUrl,
	stringInEnglish,
	getHoursPassed,
	getWeekDaysNames,
	getDayHours,
	convertUtcHourToLocalHour,
	convertLocalHourToUtcHour,
	getWeekDayName,
	isCharValid,
	getNumRange,
	getWeeksRange,
	isPastDate,
	isValidEmail,
	flattenArray,
	timeZoneForGmt,
	companyLocalDateStr,
	formatHMInCompanyTz,
	formatTimeInCompanyTz,
	formatHMInCompanyTzOrBrowserLocal,
}
